module.exports = __webpack_public_path__ + "static/media/screenDemo.fc86c6ba.mp4";